import TextComponent from './Text'
import FormGroupComponent from './FormGroup'
import SelectComponent from './Select'
import TextareaComponent from './Textarea'
import RadioComponent from './Radio'

export const Text = TextComponent
export const FormGroup = FormGroupComponent
export const Select = SelectComponent
export const Textarea = TextareaComponent
export const Radio = RadioComponent


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Form/index.js